// extracted by mini-css-extract-plugin
export default {"spinner":"EditModal_spinner__vRKvc"};